/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Form page for editing existing bike details. Handles validation
and submission of bike information updates to the system.
*/

import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import EditBikeForm from "./components/EditBikeForm";

const EditBikePage: React.FC = () => {
  const { bikeId } = useParams<{ bikeId: string }>();
  
  if (!bikeId) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <h1 className="text-2xl font-semibold">Error: No eBike ID Provided</h1>
        <Button asChild className="mt-4">
          <Link to="/bikes">Return to eBikes List</Link>
        </Button>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <Button variant="ghost" size="sm" asChild>
            <Link to={`/bikes/${bikeId}`}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to eBike Details
            </Link>
          </Button>
          <h1 className="text-3xl font-bold tracking-tight">Edit eBike</h1>
          <p className="text-muted-foreground">
            Update eBike details, status, and maintenance information
          </p>
        </div>
      </div>
      
      <EditBikeForm bike={bikeId} />
    </div>
  );
};

export default EditBikePage;
